<template>
  <div class="box catalog">
    <div class="part-title">
      &diams;<span class="inline-title">{{ curActive }}</span>
    </div>
    <ul class="notes">
        <li class="note-line" v-for="record in records" :key="record.id" @click="setPage(record.page)">
          <div class="text">{{ record.volumeTitleAndArticleTitle }}</div>
          <div class="right-tip">
            <div class="page">{{ record.page }}</div>
          </div>
        </li>
    </ul>
  </div>
</template>

<script>
import Custom from '@/api/custom'
import { getSearchParams } from '@/utils'
let api = new Custom('bookVolumeData')
export default {
  data () {
    return {
      records: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      bookId: getSearchParams(window.location.href).bookId,
      volumeName: getSearchParams(window.location.href).volumeName,
      curActive: '目录'
    }
  },
  computed: {
  },
  methods: {
    getCatalog () {
      api
        .getRecords({
          pageIndex: 1,
          pageSize: 999,
          bookId: this.bookId,
          volumeName: this.volumeName
        })
        .then(res => {
          this.records = res.rows
        })
    },
    setPage (page) {
      this.$bus.$emit('setPage', page.replace(/[^\d]/g, ''))
    }
  },
  mounted () {
    this.getCatalog()
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.catalog {
  width: 100%;
  // height: 436px;
  margin-top: 11px;
  .cata-content {
    width: 100%;
    height: 300px;
    overflow-y: auto;
  }
  .btn-group {
    display: flex;
    border: 2px solid #7c1823;
    width: fit-content;
    margin-top: 16px;
    margin-left: 130px;
    .btn {
      padding: 4px 16px;
      .font-size-default;
      color: #7c1823;
      cursor: pointer;
      &:hover,
      &.active {
        background-color: #7c1823;
        color: white;
      }
    }
  }
  .bookmark {
    width: 100%;
    .item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 24px;
      color: #7a7374;
      cursor: pointer;
    }
  }
  .notes {
    width: 100%;
    .note-line {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      color: #7a7374;
      cursor: pointer;
      height: 22px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
      margin-top: 12px;
      .font-size-default;
      .text {
        padding: 0 8px;
        background-color: white;
        max-width: 292px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .right-tip {
        background-color: white;
        display: flex;
        align-items: center;
        .page {
          color: #646464;
          margin-right: 16px;
          .font-size-small;
        }
      }
    }
  }
  /deep/ .el-tree {
    background-color: rgba(0, 0, 0, 0);
    font-family: "FangZhengKaiTi-GBK";
  }
}
</style>
